// ===========================================================================
// Badges — pills de severidad reutilizables.
//
// SeverityBadge: tiempo desde la última visita, coloreado con la paleta de
// severidad (verde → rojo). El texto literal queda siempre visible para no
// depender solo del color (accesibilidad / daltonismo).
//
// MetalBadge: nivel de metal del plan ACA (Bronze/Silver/Gold/Platinum).
// ===========================================================================
import React from "react";
import { Chip } from "@mui/material";
import {
  TIME_BUCKET_BADGE_COLORS,
  METAL_LEVEL_COLORS,
  EMPTY_PLACEHOLDER,
} from "../../common/constants";

export function SeverityBadge({ bucket, size = "small" }) {
  if (!bucket) return <span style={{ color: "#9ca3af" }}>{EMPTY_PLACEHOLDER}</span>;
  const colors = TIME_BUCKET_BADGE_COLORS[bucket] || { bg: "#f1f5f9", text: "#475569" };
  return (
    <Chip
      label={bucket}
      size={size}
      aria-label={`Time since last visit: ${bucket}`}
      sx={{
        height: 22,
        fontSize: "0.72rem",
        fontWeight: 700,
        bgcolor: colors.bg,
        color: colors.text,
        border: "none",
      }}
    />
  );
}

export function MetalBadge({ level, size = "small" }) {
  if (!level) return <span style={{ color: "#9ca3af" }}>{EMPTY_PLACEHOLDER}</span>;
  const colors = METAL_LEVEL_COLORS[level] || { bg: "#f1f5f9", text: "#475569" };
  return (
    <Chip
      label={level}
      size={size}
      sx={{
        height: 20,
        fontSize: "0.68rem",
        fontWeight: 600,
        bgcolor: colors.bg,
        color: colors.text,
        border: "none",
      }}
    />
  );
}
